import React from 'react'
import { SvgIcon } from '@material-ui/core'

const LockIcon = (props) => {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="50.663" height="63.333" viewBox="0 0 50.663 63.333">
      <path data-name="Path 13704" d="M1014 606.666a9.536 9.536 0 0 1 9.5 9.5v9.5h-19v-9.5a9.536 9.536 0 0 1 9.5-9.5zm15.83 19v-9.5a15.831 15.831 0 1 0-31.663 0v9.5H995a6.334 6.334 0 0 0-6.333 6.334v25.333a6.333 6.333 0 0 0 6.333 6.333h38a6.329 6.329 0 0 0 6.33-6.333V632a6.329 6.329 0 0 0-6.33-6.334zM995 632h38v25.333h-38z" transform="translate(-988.667 -600.333)" fill="#fff" />
    </SvgIcon>
  )
}

export default LockIcon
